import React, { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import "./ChatContainer.css";

import botIcon from "../images/bot_icon.png";
import userIcon from "../images/user_icon.png";
import headerIcon from "../images/chatbot_image.png";

const LoadingIndicator = () => (
  <span className="loading-indicator">
    <i className="fas fa-spinner fa-spin loading-icon"></i>
  </span>
);

const ChatContainer = () => {
  const [messages, setMessages] = useState([
    {
      content:
        "Hello! I'm the Lafarge Chatbot, here to assist you with any questions about our products and services. How can I help you today?",
      sender: "assistant",
      isLoading: false,
    },
  ]);
  const [input, setInput] = useState("");
  const chatRef = useRef(null);

  const apiUrl = process.env.REACT_APP_API_URL;

  const addMessage = (content, sender, isLoading = false) => {
    setMessages((prevMessages) => [
      ...prevMessages,
      { content, sender, isLoading },
    ]);
  };

  const typeBotMessage = (response) => {
    let i = 0;

    const type = () => {
      setMessages((prevMessages) => {
        const updatedMessages = [...prevMessages];
        const botMsgIndex = updatedMessages.length - 1;  

        if (i < response.length) {
          updatedMessages[botMsgIndex] = {
            content: response.slice(0, i + 1), 
            sender: "assistant",
            isLoading: true,  
          };
          i++;
          setTimeout(type, 50);  
        } else {
          updatedMessages[botMsgIndex] = {
            content: response,  
            sender: "assistant",
            isLoading: false,  
          };
        }
        return updatedMessages;
      });

      // Scroll automático al final
      if (chatRef.current) {
        chatRef.current.scrollTop = chatRef.current.scrollHeight;
      }
    };

    type(); 
  };

  const sendMessage = async () => {
    if (!input.trim()) {
      alert("Please type a message before sending!");
      return;
    }

    addMessage(input, "user");
    setInput("");

    addMessage("", "assistant", true);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question: input.trim() }),
      });
      const data = await response.json();
      console.log("Data received:", data);
      const botResponse =
        data?.response || "Sorry, I couldn't process your request.";

      // Cuando llega la respuesta, se escribe progresivamente sobre el placeholder
      typeBotMessage(botResponse);
    } catch (error) {
      console.error("Error:", error);
      typeBotMessage("Sorry, I couldn't process your request.");
    }
  };

  const handleReset = () => {
    setMessages([
      {
        content:
          "Hello! I'm the Lafarge Chatbot, here to assist you with any questions about our products and services. How can I help you today?",
        sender: "assistant",
        isLoading: false,
      },
    ]);
  };

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="chat-wrapper">
      <div className="chat-header">
        <div className="header-left">
          <img src={headerIcon} alt="Bot Icon" className="bot-icon" />
          <span className="chat-title">Lafarge Chatbot</span>
        </div>
        <img src={require("../images/logo.png")} alt="Lafarge Logo" className="lafarge-logo" />
      </div>
  
      <div className="chat-box">
        <div className="chat" ref={chatRef}>
          {messages.map((msg, index) => (
            <div key={index} className={`message ${msg.sender}`}>
              <img
                src={msg.sender === "user" ? userIcon : botIcon}
                alt={msg.sender === "user" ? "User Icon" : "Bot Icon"}
                className="chat-icon"
              />
              <div className="message-content">
                {msg.sender === "assistant" && (
                 <div className="role-label">Assistant</div>
                )}
                <ReactMarkdown>{msg.content}</ReactMarkdown>
                {msg.isLoading && <LoadingIndicator />}
              </div>
            </div>
          ))}
        </div>
  
        <div className="input-container">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your question here..."
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <button onClick={sendMessage} disabled={!input.trim()}>
            <i className="fas fa-paper-plane"></i>
          </button>
          <button className="reset-btn" onClick={handleReset}>
            <i className="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>
    </div>
  );
}  

export default ChatContainer;
